import Divider from '@mui/material/Divider'
import TopMenu from './MainGroup/TopMenu'
import Structure from './Structure'

export function MainGroup() {
  return (
    <>
      <TopMenu />
      <Divider sx={{ my: 3 }} />
      <Structure />
    </>
  )
}

export default MainGroup
